import classNames from 'classnames';
import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';

interface OnboardingCtaProps {
  className?: string;
  onClick?: () => void;
}

export default function OnboardingCta({ className, onClick }: OnboardingCtaProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <button className={classNames('cta', className)} onClick={onClick}>
        {t('onboarding.banner.helpMeSearchCta')}
      </button>
      <style jsx>{`
        .cta {
          width: 140px;
          height: 36px;
          color: ${colors.WHITE};
          border: 1px solid ${colors.ALB2};
          border-radius: 8px;
          background-color: ${colors.ALB2};
          font-size: 14px;
          font-weight: 600;
        }
      `}</style>
    </>
  );
}
